<!-- Modal Header with standard actions -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i
      class="fa"
      [ngClass]="{
        'fa-plus-square-o': minimise,
        'fa-minus-square-o': !minimise
      }"
      style="margin-right: 10px; cursor: pointer"
      (click)="minimise = !minimise"
    ></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer"></i>
  </div>
</div>

<!-- Loading state -->
@if (showFormLoader) {
<div class="modal-body" [hidden]="minimise">
  <div class="formLoader">
    <div style="text-align: center">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
  </div>
</div>
}

<!-- Modal Body -->
@if (!showFormLoader) {
<div class="modal-body" [hidden]="minimise">
  <!-- <ul class="nav nav-pills" role="tablist">
      <li class="active">
        <a style="cursor: pointer;" class="btn-sm">Form Entry</a>
      </li>
    </ul> -->

  <div class="tab-content">
    <div
      class="tab-pane active"
      style="overflow-y: auto; max-height: calc(90vh - 200px)"
    >
      <div class="form-horizontal">
        <!-- First Panel - Basic Info -->
        <div class="panel panel-default">
          <div class="panel-body">
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
                <input
                  type="text"
                  class="form-control"
                  id="tax-year"
                  name="tax-year"
                  [(ngModel)]="configEntity.TAX_YEAR"
                  readonly
                />
              </div>

              <div class="form-group col-md-4">
                <label for="scenario-type-code"
                  ><b>Scenario Type Code<sup>*</sup>:</b></label
                >
                @if (!isEdit) {
<select
                 
                  class="form-control"
                  id="scenario-type-code"
                  name="scenario-type-code"
                  [(ngModel)]="configEntity.SCENARIO_CODE"
                  (change)="loadScenarioDesc()"
                >
                  <option [value]="">Select Scenario Type Code</option>
                  @for (
                      scenarioTypeCode of allscenarioTypeCode; track trackByIndex($index, scenarioTypeCode)) {
<option
                   
                    [value]="scenarioTypeCode.SCENARIO_TYPE_CODE"
                  >
                    {{ scenarioTypeCode.SCENARIO_TYPE_CODE }}
                  </option>
}
                </select>
}
                @if (isEdit) {
<input
                 
                  type="text"
                  class="form-control"
                  id="scenario-type-code-readonly"
                  name="scenario-type-code-readonly"
                  [(ngModel)]="configEntity.SCENARIO_CODE"
                  readonly
                />
}
                @if (
                    configEntity.SCENARIO_CODE_NOT_VALID &&
                    !configEntity.SCENARIO_CODE
                  ) {
<small
                  class="text-danger"
                 
                >
                  Please provide Scenario Type Code
                </small>
}
              </div>

              <div class="form-group col-md-4">
                <label for="scenario-desc"><b>Scenario Desc:</b></label>
                <input
                  type="text"
                  class="form-control"
                  id="scenario-desc"
                  name="scenario-desc"
                  [(ngModel)]="configEntity.SCENARIO_DESC"
                  readonly
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="scenario"><b>Scenario:</b></label>
                <input
                  type="text"
                  class="form-control"
                  id="scenario"
                  name="scenario"
                  [(ngModel)]="configEntity.SCENARIO"
                  readonly
                />
              </div>

              <div class="form-group col-md-6">
                <label for="jcd_key"><b>JCD Key:</b></label>
                <input
                  type="text"
                  class="form-control"
                  id="jcd_key"
                  name="jcd_key"
                  [(ngModel)]="configEntity.JCD_KEY"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Second Panel - Schedule and Dates -->
        <div class="panel panel-default">
          <div class="panel-body">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="scheduleInd"
                  ><b>Schedule Indicator<sup>*</sup>:</b></label
                >
                <select
                  class="form-control"
                  id="scheduleInd"
                  name="scheduleInd"
                  [(ngModel)]="configEntity.SCHEDULE_IND"
                  (change)="scheduleChanged()"
                >
                  <option value="A">Active</option>
                  <option value="I">Inactive</option>
                </select>
                @if (
                    configEntity.SCHEDULE_IND_NOT_VALID &&
                    !configEntity.SCHEDULE_IND
                  ) {
<small
                  class="text-danger"
                 
                >
                  Please provide Schedule Indicator
                </small>
}
              </div>
            </div>

            <div class="form-row date-fields">
              <div class="form-group col-md-6">
                <label for="batch-start-date"
                  ><b>Batch Start Date<sup>*</sup>:</b></label
                >
                <input
                  type="date"
                  class="form-control date-content"
                  id="batch-start-date"
                  [(ngModel)]="batchStartDateFormatted"
                  (change)="onDateChange('start', $event)"
                  [disabled]="false"
                  [class.is-invalid]="
                    configEntity.BATCH_START_DT_NOT_VALID &&
                    !configEntity.BATCH_START_DT
                  "
                />
                <!-- <div class="input-group">
                    <input type="date" class="form-control" id="batch-start-date" name="batch-start-date"
                           [(ngModel)]="batchStartDateFormatted"
                           (change)="onDateChange('start')" required>
                  </div> -->
                @if (
                    configEntity.BATCH_START_DT_NOT_VALID &&
                    !configEntity.BATCH_START_DT
                  ) {
<small
                  class="text-danger"
                 
                >
                  Please provide Batch Start Date
                </small>
}
              </div>

              <div class="form-group col-md-6">
                <label for="batch-end-date"><b>Batch End Date:</b></label>
                <input
                  type="date"
                  class="form-control date-content"
                  id="batch-end-date"
                  [(ngModel)]="batchEndDateFormatted"
                  (change)="onDateChange('end', $event)"
                  [disabled]="configEntity.SCHEDULE_IND === 'A'"
                />
                <!-- <div class="input-group">
                    <input type="date" class="form-control" id="batch-end-date" name="batch-end-date"
                           [(ngModel)]="batchEndDateFormatted"
                           (change)="onDateChange('end')"
                           [disabled]="configEntity.SCHEDULE_IND === 'A'">
                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Footer with standardized buttons -->
<div class="modal-footer">
  <button
    class="save-button"
    type="button"
    [disabled]="isSaveClicked"
    (click)="save()"
  >
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    @if (!isEdit) {
<span>Create</span>
}
    @if (isEdit) {
<span>Update</span>
}
  </button>

  <button class="reset-button" type="button" (click)="reset()">Reset</button>

  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>

  @if (isEdit) {
<button
   
    class="delete-button"
    type="button"
    [disabled]="isSaveClicked"
    (click)="delete()"
  >
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Delete
  </button>
}
</div>
